/** The first-move banner (unit convention §1 sub-leaf). */
import React from 'react';

import type {Side} from '@/Store/liveGame/state';

import {useFirstMoveBannerModel} from './FirstMoveBanner.model';
import FirstMoveBannerView from './FirstMoveBanner.View';

export default React.memo(function FirstMoveBanner({side}: {side: Side}) {
  return <FirstMoveBannerView {...useFirstMoveBannerModel(side)} />;
});
